/* eslint-disable react/button-has-type */
/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef, createContext } from 'react';
import { useHistory, Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import Fuse from 'fuse.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
// Swiper
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';

import { Card, Header, Loading } from '../components';
import logo from '../logo.svg';
import { SelectProfileContainer } from './profiles';
import { FooterContainer } from './footer';
import useViewport from '../hooks/useViewport';
import '../components/icon.css';
import './browse.scss';
import './card.scss';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const IconContainer = styled.div`
  display: flex;
`;

export const Wrapper = styled.div`
  overflow: hidden;
`;

export const FeatureContext = createContext();

export function BrowseContainer({ slides }) {
  const [category] = useState('series');
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [slideRows, setSlideRows] = useState([]);

  const user = { photoURL: 'https://i.ibb.co/MNg2ctp/mansdev.png' };

  SwiperCore.use([Navigation, Pagination]);

  const { width } = useViewport();

  //  const { loading, error, data: results } = rowData;

  // Custom Swiper config
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const customSwiperParams = {
    observer: true,
    observeParents: true,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    },
    breakpoints: {
      1378: { slidesPerView: 4, slidesPerGroup: 4 },
      998: { slidesPerView: 3.5, slidesPerGroup: 3.5 },
      625: { slidesPerView: 3, slidesPerGroup: 3 },
      330: { slidesPerView: 2, slidesPerGroup: 2 },
      0: { slidesPerView: 1.5, slidesPerGroup: 1.5 },
    },
    loopAdditionalSlides:
      width >= 1378 ? 3 : width >= 998 ? 3 : width >= 625 ? 2 : 2,
    pagination: true,
    loop: false,
    grabCursor: false,
    draggable: false,
    preventClicksPropagation: true,
    preventClicks: true,
    slideToClickedSlide: false,
    allowTouchMove: true,
  };

  const rightMouseOver = (e) => {
    if (e.currentTarget.classList.contains('right')) {
      e.currentTarget.parentElement.classList.add('is-right');
    } else if (e.currentTarget.classList.contains('left')) {
      e.currentTarget.parentElement.classList.add('is-left');
    }
  };

  const rightMouseOut = (e) => {
    e.currentTarget.parentElement.classList.remove('is-right', 'is-left');
  };

  const insertPositionClassName = (index) => {
    const i = index + 1;

    if (i === 1) return 'left';
    else if (i === 20) return 'right';

    if (width >= 1378) {
      if ([7, 13, 19].includes(i)) return 'left';
      else if ([6, 12, 18].includes(i)) return 'right';
    } else if (width >= 998) {
      if ([5, 9, 13, 17].includes(i)) return 'left';
      else if ([4, 8, 12, 16].includes(i)) return 'right';
    } else if (width >= 768) {
      if ([4, 7, 10, 13, 16].includes(i)) return 'left';
      else if ([3, 6, 9, 12, 15, 18].includes(i)) return 'right';
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, [profile.displayName]);

  useEffect(() => {
    setSlideRows(slides[category]);
  }, [slides, category]);

  useEffect(() => {
    const fuse = new Fuse(slideRows, {
      keys: ['data.description', 'data.title', 'data.genre'],
    });
    const results = fuse.search(searchTerm).map(({ item }) => item);

    if (slideRows.length > 0 && searchTerm.length > 3 && results.length > 0) {
      setSlideRows(results);
    } else {
      setSlideRows(slides[category]);
    }
  }, [searchTerm]);

  const history = useHistory();

  return profile.displayName ? (
    <>
      {loading ? <Loading src={profile.photoURL} /> : <Loading.ReleaseBody />}

      <Header src="damian-patkowski-T-LfvX-7IVg-unsplash">
        <Header.Frame>
          <Header.Group>
            <Header.Link to="/">
              <Header.Logo src={logo} alt="Mansflix" />
            </Header.Link>

            {/* <Header.TextLink
              active={category === 'series' ? 'true' : 'false'}
              onClick={() => setCategory('series')}
            >
              Series
            </Header.TextLink> */}

            <Header.TextLink onClick={() => history.push('/aboutme')}>
              About
            </Header.TextLink>
          </Header.Group>
          <Header.Group>
            <Header.Search
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
            <Header.Profile>
              <Header.Picture src={profile.photoURL} />
              <Header.Dropdown>
                <Header.Group>
                  <Header.Picture src={profile.photoURL} />
                  <Header.TextLink>{profile.displayName}</Header.TextLink>
                </Header.Group>
                <hr />
                <Header.Group>
                  <Header.TextLink onClick={() => history.push('/aboutme')}>
                    About
                  </Header.TextLink>
                </Header.Group>
                <Header.Group>
                  <Header.SocialLink
                    href="https://www.linkedin.com/in/mansour-mahamat-salle-138b73138/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Linkedin
                  </Header.SocialLink>
                </Header.Group>

                <Header.Group>
                  <Header.SocialLink
                    href="https://github.com/mansmahamat"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Github
                  </Header.SocialLink>
                </Header.Group>
                <Header.Group>
                  <Header.SocialLink
                    href="https://twitter.com/Mans_JS"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Twitter
                  </Header.SocialLink>
                </Header.Group>
                <hr />
                <Header.Group>
                  <Header.TextLink
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    Sign out
                  </Header.TextLink>
                </Header.Group>
              </Header.Dropdown>
            </Header.Profile>
          </Header.Group>
        </Header.Frame>

        <Header.Feature>
          <Header.Title>
            <img
              src="https://fontmeme.com/permalink/210805/a9c04e8fed07cddd12dbb241f8d566a8.png"
              alt="netflix-font"
              border="0"
              width="32"
            />

            <Header.FeatureCallOut>
              Learn more about Mansour
            </Header.FeatureCallOut>
          </Header.Title>

          <Header.Text>
            Hi there ! My name is Mansour and I'm a Frontend Developer at BROCC{' '}
            <br />I moved from France to Sweden with my family, at BROCC I build
            useful & amazing website with React, Typescript & Styled-Component.
          </Header.Text>
          <Header.PlayButton onClick={() => history.push('/aboutme')}>
            More
          </Header.PlayButton>
        </Header.Feature>
      </Header>

      <Wrapper>
        {slideRows.map((slideItem) => (
          <div className="Row">
            <p className="Row__Title">{slideItem.title}</p>
            <Card key={`${category}-${slideItem.title.toLowerCase()}`}>
              <div className="Row__slider--mask left" ref={navigationPrevRef}>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className="Row__slider--mask-icon left"
                  size="3x"
                  style={{ color: 'white' }}
                />
              </div>
              <div className="Row__slider--mask right" ref={navigationNextRef}>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="Row__slider--mask-icon right"
                  size="3x"
                  style={{ color: 'white' }}
                />
              </div>
              <Swiper
                {...customSwiperParams}
                spaceBetween={2}
                slidesPerView={4}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;
                }}
              >
                {slideItem.data.map((item, i) => (
                  <SwiperSlide
                    key={i}
                    className={insertPositionClassName(i)}
                    onMouseOver={rightMouseOver}
                    onMouseOut={rightMouseOut}
                  >
                    <Card.Item
                      key={item.docId}
                      item={item}
                      className="Row__poster"
                    >
                      <>
                        <img
                          src={`/images/${category}/${item.genre}/${item.slug}/small.jpg`}
                          alt="{fallbackTitle}"
                        />
                        <div className="Row__poster__fallback">
                          <span>{item.title}</span>
                        </div>
                      </>

                      <div className="Row__poster-info">
                        <div className="Row__poster-info--iconswrp">
                          {item.video && (
                            <Link
                              className="Row__poster-info--icon icon--play"
                              to={{
                                pathname: '/watch',
                                state: {
                                  title: item.title,
                                  video: item.video,
                                  genre: item.genre,
                                },
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faPlay}
                                size="1x"
                                color="#2A2A2A"
                              />
                            </Link>
                          )}

                          <button className="Row__poster-info--icon icon--toggleModal">
                            <FontAwesomeIcon size="1x" icon={faChevronDown} />
                          </button>
                        </div>
                        <div className="Row__poster-info--title">
                          <h3>{item.title}</h3>
                        </div>
                        <div className="Row__poster-info--genres">
                          <span className="genre-title">99.9% recommended</span>
                          <span className="genre-title--date">
                            ● {item.date ? item.date : 2022} ●
                          </span>
                          <span className="genre-title--age">12+</span>
                        </div>
                      </div>
                    </Card.Item>
                  </SwiperSlide>
                ))}
              </Swiper>

              <Card.Feature category={category} />
            </Card>
          </div>
        ))}
      </Wrapper>

      <FooterContainer />
    </>
  ) : (
    <SelectProfileContainer user={user} setProfile={setProfile} />
  );
}
